import { render } from "./ImportExportForm.vue?vue&type=template&id=6ba6188c"
import script from "./ImportExportForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportExportForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/learning_module/components/lm/ImportExportForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ba6188c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ba6188c', __exports__)) {
    api.reload('6ba6188c', __exports__)
  }
  
  module.hot.accept("./ImportExportForm.vue?vue&type=template&id=6ba6188c", () => {
    api.rerender('6ba6188c', render)
  })

}


export default __exports__